/**
 * The login page with the page to come back to, which the login flow opens after signing in.
 * The route guard sends a signed-out visitor here, and so does an ended session.
 */
export function loginRedirectPath(currentUrl: string): string {
    return `/login?redirectTo=${encodeURIComponent(currentUrl)}`;
}

/**
 * Leaves the current page for the login page, replacing it in the history. A full load, as
 * logging out does, so nothing the signed-in app kept in memory survives.
 */
export function redirectToLogin(): void {
    window.location.replace(loginRedirectPath(window.location.href));
}
